import React from 'react';
import { CommandButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { CHART_COLORS } from '../../../utilities/colors';

function threshold(props){
  const { plotIndex, threshold, editThreshold, saveThreshold, removeThreshold, updateSavedThreshold, removeThresholdFromFavorites } = props;
  const { edit, name, index, value, width, color, dash, show, key, saved, locked, changed } = threshold;

  const items = [
    {
      key: 'hide',
      text: show ? 'Hide' : 'Show',
      iconProps: { iconName: show ? 'RedEye' : 'Hide' },
      onClick: () => editThreshold({show: !show}, plotIndex, index)
    },
    {
      key: 'edit',
      text: 'Edit',
      iconProps: { iconName: 'Edit' },
      onClick: () => editThreshold({edit: !edit}, plotIndex, index)
    },
    {
      key: 'trash',
      text: 'Delete',
      iconProps: { iconName: 'Trash' },
      onClick: () => removeThreshold(plotIndex, key)
    },
  ];

  if(saved){
    items.push({
      key: 'saved',
      text: 'Remove From My Thresholds',
      iconProps: {iconName: 'Unsubscribe'},
      onClick: () => removeThresholdFromFavorites(threshold, plotIndex)
    })
  };

  if(!saved && !locked){
    items.push({
      key: 'save',
      text: 'Save To My Thresholds',
      iconProps: { iconName: 'Save' },
      onClick: () => saveThreshold(threshold, plotIndex)
    })
  };

  let classNames = edit ? ['threshold'] : ['read-threshold'];
  if(edit){ classNames.push('editing')};
  if(!show){ classNames.push('no-show')}

  if(edit){
    return (
      <div className={classNames.join(' ')}>
        <TextField
          underlined
          label="Name:"
          value={name} 
          onChange={(e, name) => editThreshold({name, changed: true}, plotIndex, index)}
        />
        <TextField
          underlined
          label="Value:"
          type='number' 
          value={value} 
          onChange={(e, value) => editThreshold({value, changed: true}, plotIndex, index)}
        />
        <div className='flex-row'>
          <Dropdown
            placeholder="Select an Dash Type"
            label="Line Style:"
            id="dash-dropdown"
            style={{marginRight: '5px'}}
            ariaLabel="Dash Dropdown"
            selectedKey={ dash }
            options={[
              { key: 'solid', text: 'Solid' },
              { key: 'dot', text: 'Dot' },
              { key: 'dash', text: 'Dash' },
              { key: 'longdash', text: 'Long Dash' },
              { key: 'dashdot', text: 'Dash Dot' },
              { key: 'longdashdot', text: 'Long Dash Dot'}
            ]}
            onChange={(e, {key}) => editThreshold({dash: key, changed: true}, plotIndex, index)}
          />
          <Dropdown
            placeholder="Select a Color"
            label="Color:"
            id="color-dropdown"
            ariaLabel="Color Dropdown"
            style={{marginRight: '5px'}}
            selectedKey={ color }
            onRenderTitle={(item) => {
              let key = item[0].key;
              return <div className='custom-dropdown' key={`title-${key}`}>
                <Icon style={{ marginRight: '8px', color: key }} iconName='CircleFill'/>
              </div>
            }}
            onRenderItem={({key}) => {
              return <div className='custom-dropdown' key={key} onClick={() => editThreshold({color: key, changed: true}, plotIndex, index)}>
                <Icon style={{ marginRight: '8px', color: key }} iconName='CircleFill'/>
              </div>
            }}
            options={CHART_COLORS.map(color => ({key: color, text: color}))}
          />
          <Dropdown
            placeholder="Line Width"
            label="Width:"
            id="color-dropdown"
            ariaLabel="Line Width Dropdown"
            selectedKey={ width }
            options={[0,1,2,3,4,5,6,7,8,9,10].map(width => ({key: width, text: `${width}px`}))}
            onChange={(e, {key}) => editThreshold({width: key, changed: true}, plotIndex, index)}
          />
        </div>
        <div className='threshold-controls'>
          <IconButton
            className='edit'
            iconProps={{ iconName: 'Uneditable' }}
            title="Close Edit"
            ariaLabel="Close Edit"
            onClick={() => editThreshold({edit: !edit}, plotIndex, index)}
          />
          <IconButton
            className='show'
            iconProps={{ iconName: threshold.show ? 'RedEye' : 'Hide' }}
            title="Show In Chart"
            ariaLabel="Show In Chart"
            onClick={() => editThreshold({show: !show}, plotIndex, index)}
          />
          <IconButton
            className='trash'
            iconProps={{ iconName: 'Trash' }}
            title="Delete"
            ariaLabel="Delete"
            onClick={() => removeThreshold(plotIndex, key)}
          />
          {
            saved ? (
              <IconButton
                className='save'
                iconProps={{ iconName: 'Unsubscribe'}}
                title="Remove From Favorites"
                ariaLabel="Remove From Favorites"
                onClick={() => removeThresholdFromFavorites(threshold, plotIndex)}
              />
            ) : locked ? null : (
              <IconButton
                className='save'
                iconProps={{ iconName: 'Save'}}
                title="Save to Favorites"
                ariaLabel="Save to Favorites"
                onClick={() => saveThreshold(threshold, plotIndex)}
              />
            )
          }
          {
            !locked && saved && (
              <IconButton
                className='save'
                disabled={!changed}
                iconProps={{ iconName: 'SaveAs'}}
                title="Save Changes"
                ariaLabel="Save Changes"
                onClick={() => updateSavedThreshold(threshold, plotIndex)}
              />
            )
          }
        </div>
      </div>
    )
  }
  return <div className={ classNames.join(' ') }>
  <p>{name || 'No Name'}: {value || 'No Value'}</p>
  <div className='threshold-controls'>
    <CommandButton menuProps={{ items }}
    />
  </div>
</div>
}

export default threshold;


// WEBPACK FOOTER //
// ./src/components/panel/items/threshold.js